@if (selectedService === ServiceType.NONE) {
    <sew-headline level="4">
        {{ 'REQUEST_SERVICE.HEADLINE' | translate }}
    </sew-headline>
}

<div class="content-container">
    <div class="teaser-container" [ngClass]="{ selected: selectedService !== ServiceType.NONE }">
        @if (selectedService === ServiceType.NONE || selectedService === ServiceType.AT_SEW) {
            <ecs-service-teaser
                class="teaser"
                [ngClass]="{ selected: selectedService === ServiceType.AT_SEW }"
                [icon]="'tool'"
                [linkText]="'REQUEST_SERVICE.TEASER.SERVICE_AT_SEW.HEADLINE' | translate"
                [text]="'REQUEST_SERVICE.TEASER.SERVICE_AT_SEW.INFO' | translate"
                [trackClickEvent]="'accessoriesAndServices.service.serviceInhouse'"
                (selectService)="requestServiceAtSew()"
            ></ecs-service-teaser>
        }

        @if (selectedService === ServiceType.NONE || selectedService === ServiceType.ON_SITE) {
            <ecs-service-teaser
                class="teaser"
                [ngClass]="{ selected: selectedService === ServiceType.ON_SITE }"
                [icon]="'house'"
                [linkText]="'REQUEST_SERVICE.TEASER.SERVICE_ON_SITE.HEADLINE' | translate"
                [text]="'REQUEST_SERVICE.TEASER.SERVICE_ON_SITE.INFO' | translate"
                [trackClickEvent]="'accessoriesAndServices.service.serviceOnsite'"
                (selectService)="requestServiceOnSite()"
            ></ecs-service-teaser>
        }

        @if (selectedService === ServiceType.NONE) {
            <ecs-service-teaser
                class="teaser"
                [icon]="'mail'"
                [linkText]="'REQUEST_SERVICE.TEASER.CONTACT_SERVICE.HEADLINE' | translate"
                [text]="'REQUEST_SERVICE.TEASER.CONTACT_SERVICE.INFO' | translate"
                [trackClickEvent]="'accessoriesAndServices.service.serviceContact'"
                (selectService)="requestContactToService()"
            ></ecs-service-teaser>
        }
    </div>

    @if (selectedService !== ServiceType.NONE) {
        <div class="request-form">
            <div class="form-data">
                <sew-headline level="4">{{ 'REQUEST_SERVICE.HEADLINE' | translate }}</sew-headline>
                <p class="introduction">{{ 'REQUEST_SERVICE.FORM.INTRODUCTION' | translate }}</p>
                <sew-input>
                    <label for="serialnumber">{{
                        'REQUEST_SERVICE.FORM.SERIAL_NUMBER.LABEL' | translate
                    }}</label>
                    <input
                        id="serialnumber"
                        type="text"
                        [value]="serialNumber"
                        (input)="updateSerialNumber($any($event.target).value)"
                        autocomplete="off"
                    />
                </sew-input>
            </div>
            <div class="button-list">
                <sew-button hierarchy="secondary">
                    <button
                        (click)="clearSelectedService()"
                        oscTrackClick="accessoriesAndServices.service.serviceBack"
                    >
                        {{ 'REQUEST_SERVICE.FORM.ACTION.BACK' | translate }}
                    </button>
                </sew-button>
                <sew-button [attr.disabled]="!serialNumber || null">
                    <a
                        class="continue-button"
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        [href]="requestServiceUrl"
                        [oscTrackClick]="
                            selectedService === ServiceType.AT_SEW
                                ? 'accessoriesAndServices.service.serviceInhouseNext'
                                : 'accessoriesAndServices.service.serviceOnsiteNext'
                        "
                    >
                        {{ 'REQUEST_SERVICE.FORM.ACTION.CONTINUE' | translate }}
                    </a>
                </sew-button>
            </div>
        </div>
    }
</div>
